import {route} from "../../../../functions/route";
import crud from "../../../../stores/crud";

const state = {
	...crud.state,
	routes: {
		index: "products",
		show: "products/:product",
		favourite: "products/:product/favourite",
	},
};

export default {
	namespaced: true,
	state,
	actions: {
		...crud.actions,
		toggleFavourite({state}, product) {
			http().patch(route(state.routes.favourite, product)).then(response => {
				let _product = _.find(state.items, ["id", product.id]);
				_product.favourite = !_product.favourite;
			});
		},
	},
	mutations: {
		...crud.mutations,
	},
	getters: {
		...crud.getters,
		products: (state) => state.items,
		favourites: (state, getters) => {
			return getters.products.filter(product => product.favourite);
			// return _.filter(state.items, product => {
			// 	return product.favourite;
			// });
		},
		productsForInstruction: (state) => (instruction) => {
			return state.items.filter(product => product.service?.id === instruction.service.id);
		},
		favouritesForInstruction: (state, getters) => (instruction) => {
			return getters.productsForInstruction(instruction).filter(product => product.favourite);
		},
	},
};
